/*
 * @Description: SDK组件相关事件监听
 */
import jsBridge from '../common/jsBridge'
import App from '../class/App'

/**
 * 销毁组件时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onComponentDestroy (componentId, eventHandle) {
    const eventName = 'onComponentDestroy';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 组件信息变更时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onComponentOptionsChanged (componentId, eventHandle) {
    const eventName = 'onComponentOptionsChanged';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 设置视图rect时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onViewRectChanged (componentId, eventHandle) {
    const eventName = 'onViewRectChanged';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 被从父视图移除时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onRemoveFromView (componentId, eventHandle) {
    const eventName = 'onRemoveFromView';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 在当前视图上添加其他视图时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onAppendView (componentId, eventHandle) {
    const eventName = 'onAppendView';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 将当前视图添加到指定视图上时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onAppendViewTo (componentId, eventHandle) {
    const eventName = 'onAppendViewTo';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 当前视图层级被置顶时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onBringViewToFront (componentId, eventHandle) {
    const eventName = 'onBringViewToFront';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 隐藏组件时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onHideView (componentId, eventHandle) {
    const eventName = 'onHideView';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 显示组件时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onShowView (componentId, eventHandle) {
    const eventName = 'onShowView';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 背景颜色改变时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onViewBgColorChanged (componentId, eventHandle) {
    const eventName = 'onViewBgColorChanged';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 透明度改变时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onViewAlphaChanged (componentId, eventHandle) {
    const eventName = 'onViewAlphaChanged';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 组件缩放改变时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onViewScaleChanged (componentId, eventHandle) {
    const eventName = 'onViewScaleChanged';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 将组件添加到目标组件的上层时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onInsertViewAbove (componentId, eventHandle) {
    const eventName = 'onInsertViewAbove';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 将组件添加到目标组件的下层时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onInsertViewBelow (componentId, eventHandle) {
    const eventName = 'onInsertViewBelow';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 组件被点击时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onClicked (componentId, eventHandle) {
    const eventName = 'onClicked';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 组件被双击时触发（暂未实现）
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onDoubleClicked (componentId, eventHandle) {
    const eventName = 'onDoubleClicked';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * Webview-加载完成时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onWebviewLoad (componentId, eventHandle) {
    const eventName = 'onWebviewLoad';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 播放器组件-视频播放时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onPlayerPlay (componentId, eventHandle) {
    const eventName = 'onPlayerPlay';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 播放器组件-暂停时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onPlayerPause (componentId, eventHandle) {
    const eventName = 'onPlayerPause';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 播放器组件-恢复播放时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onPlayerResume (componentId, eventHandle) {
    const eventName = 'onPlayerResume';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 播放器组件-停止播放时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onPlayerStop (componentId, eventHandle) {
    const eventName = 'onPlayerStop';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 播放器组件-更新帧时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onPlayerUpdateFrame (componentId, eventHandle) {
    const eventName = 'onPlayerUpdateFrame';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 播放器组件-静音时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onPlayerMute (componentId, eventHandle) {
    const eventName = 'onPlayerMute';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 播放器组件-取消静音时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onUnmute (componentId, eventHandle) {
    const eventName = 'onUnmute';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 播放器组件-播放完成时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onPlayerFinish (componentId, eventHandle) {
    const eventName = 'onPlayerFinish';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 播放器组件-播放失败时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onPlayerFailed (componentId, eventHandle) {
    const eventName = 'onPlayerFailed';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 播放器组件-缓冲超时时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onPlayerTimeout (componentId, eventHandle) {
    const eventName = 'onPlayerTimeout';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 播放器组件-player上的关闭按钮被点击时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onPlayerCloseBtnClicked (componentId, eventHandle) {
    const eventName = 'onPlayerCloseBtnClicked';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}
/**
 * 播放器组件-player上的静音按钮被点击时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onPlayerMuteBtnClicked (componentId, eventHandle) {
    const eventName = 'onPlayerMuteBtnClicked';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 播放器组件-设置or替换视频源时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onSourceChanged (componentId, eventHandle) {
    const eventName = 'onSourceChanged';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * 播放器组件-设置渲染方式变更时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onRenderTypeChanged (componentId, eventHandle) {
    const eventName = 'onRenderTypeChanged';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * StoreKitView-预加载成功时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onPreloadSuccess (componentId, eventHandle) {
    const eventName = 'onPreloadSuccess';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}





/**
 * SubPlayTemplateView组件-web的渲染结果
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onSubPlayTemplateViewLoad (componentId, eventHandle) {
    const eventName = 'onSubPlayTemplateViewLoad';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * SubPlayTemplateView组件-通知H5 用户点击了关闭按钮
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onSubPlayTemplateViewCloseBtnClicked (componentId, eventHandle) {
    const eventName = 'onSubPlayTemplateViewCloseBtnClicked';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * SubPlayTemplateView组件
 * 组件 showsuccess （视频开始播放）时的回调
 * （原本给开发者的，现在给H5，H5决定是否给SDK）
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onSubPlayTemplateViewPlayStart (componentId, eventHandle) {
    const eventName = 'onSubPlayTemplateViewPlayStart';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * SubPlayTemplateView组件
 * 组件 showfailed （播放视频失败）时的回调
 * （原本给开发者的，现在给H5，H5决定是否给SDK）
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onSubPlayTemplateViewPlayFailed (componentId, eventHandle) {
    const eventName = 'onSubPlayTemplateViewPlayFailed';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * SubPlayTemplateView组件
 * 组件 playcompleted 时的回调
 * （原本给开发者的，现在给H5，H5决定是否给SDK）
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onSubPlayTemplateViewPlayCompleted (componentId, eventHandle) {
    const eventName = 'onSubPlayTemplateViewPlayCompleted';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * SubPlayTemplateView组件
 * 组件 endcardshowsuccess 时的回调
 * （原本给开发者的，现在给H5，H5决定是否给SDK）
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onSubPlayTemplateViewEndcardShowSuccess (componentId, eventHandle) {
    const eventName = 'onSubPlayTemplateViewEndcardShowSuccess';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * SubPlayTemplateView组件
 * 组件触发 clicked 时的回调
 * （原本给开发者的，现在给H5，H5决定是否给SDK）
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onSubPlayTemplateViewClicked (componentId, eventHandle) {
    const eventName = 'onSubPlayTemplateViewClicked';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}

/**
 * SubPlayTemplateView组件
 * 组件 dismissed 时的回调
 * （原本给开发者的，现在给H5，H5决定是否给SDK）
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onSubPlayTemplateViewDismissed (componentId, eventHandle) {
    const eventName = 'onSubPlayTemplateViewDismissed';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}



/**
 * 组件关闭按钮被点击时触发
 * @param componentId | Number
 * @param eventHandle | Function
 */
export function onCloseBtnClicked (componentId, eventHandle) {
    const eventName = 'onCloseBtnClicked';
    jsBridge.addComponentEventListener(componentId, eventName, eventHandle)
}




